<template>
  <div class="row">
    <div class="panel bg-transparent columns large-6 medium-12 large-centered" v-if="componentReady">

      <table style="width: 100%;" class="dataTable Display">
        <thead>
          <tr>
            <td colspan="2" class="text-center">
              <h5 class="no-margin" v-text="t('forms.new_individual.IC_0000')"/>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="text-center">
              <a class='button mini radius no-margin' href='https://mail.google.com' target='_blank' v-html="t('forms.new_individual.IC_0013')"></a>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.add_a_contractor.IC_0018')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Email"
                :placeholder="t('register.enter_email')"
                type="text"
                class="no-margin"
                maxlength="100">
              <small
                v-if="emailError && displayError"
                class="error"
                v-text="t('member_basic_edit.IC_0037')"/>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div>
                <span v-text="t('password_change.password_new_must')" />
                <ul>
                  <li v-html="t('password_change.password_length')"/>
                  <li v-html="t('password_change.password_uppercase')"/>
                  <li v-html="t('password_change.password_number')"/>
                  <li v-html="t('password_change.password_common')"/>
                  <li v-html="t('password_change.password_constitutive_characters')"/>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.login_cred.IC_0004')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Password"
                :placeholder="t('register.enter_password')"
                type="password"
                autocomplete="off"
                class="no-margin">
              <small
                v-if="passwordError && displayError"
                class="error"
                v-text="t('eInvoicing.password_meet_requirements')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.login_cred.IC_0006')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.PasswordMatch"
                :placeholder="t('register.re_enter_password')"
                type="password"
                autocomplete="off"
                class="no-margin">
              <small
                v-if="passwordMatchError && displayError"
                class="error"
                v-text="t('xajax.newcontractor.server.IC_0014')"/>
            </td>
          </tr>
        </tbody>
      </table>

      <table style="width: 100%;" class="dataTable Display">
        <thead>
          <tr>
            <td colspan="2" class="text-center">
              <h5 class="no-margin" v-text="t('forms.new_individual.IC_0014')"/>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0001')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Firstname"
                type="text"
                class="no-margin"
                maxlength="20">
              <small
                v-if="firstnameError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0008')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0002')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Lastname"
                type="text"
                class="no-margin"
                maxlength="20">
              <small
                v-if="lastnameError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0009')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0003')"/>
            </td>
            <td>
              <input
                v-model="personalInfo.Title"
                type="text"
                class="no-margin"
                maxlength="40">
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0005')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Tel"
                type="text"
                class="no-margin"
                maxlength="14">
              <small
                v-if="telError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0011')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0006')"/>
            </td>
            <td>
              <input
                v-model="personalInfo.Cell"
                type="text"
                class="no-margin"
                maxlength="14">
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0008')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Street"
                type="text"
                class="no-margin"
                maxlength="58">
              <small
                v-if="streetError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0014')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0009')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.City"
                type="text"
                class="no-margin"
                maxlength="30">
              <small
                v-if="cityError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0015')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0011')"/>
              <span class="required">*</span>
            </td>
            <td>
              <select
                v-model="localCountryId"
                style="box-sizing: border-box;"
                class="no-margin">
                <option
                  value="0"
                  v-text="t('admin.edit_question.IC_0000')"/>
                <option
                  v-for="country in displayData.geoInfo.countries"
                  :value="country.CountryID"
                  v-text="country.Name"/>
              </select>
              <small
                v-if="countryError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0017')"/>
            </td>
          </tr>
          <tr v-if="localCountryId !== '0'">
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0010')"/>
              <span class="required">*</span>
            </td>
            <td>
              <select
                v-model="localProvinceId"
                style="box-sizing: border-box;"
                class="no-margin">
                <option
                  value="0"
                  v-text="t('admin.edit_question.IC_0000')"/>
                <option
                  v-for="province in getProvinces()"
                  :value="province.zone_id"
                  v-html="province.Name"/>
              </select>
              <small
                v-if="provinceError && displayError"
                class="error"
                v-text="t('xajax.mycontactinfo.server.IC_0016')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span v-text="t('forms.new_contractor_contact.IC_0012')"/>
              <span class="required">*</span>
            </td>
            <td>
              <input
                v-model="personalInfo.Postal"
                type="text"
                class="no-margin"
                maxlength="14">
              <small
                v-if="postalError && displayError"
                class="error no-margin"
                v-text="t('xajax.mycontactinfo.server.IC_0018')"/>
              <small
                v-if="postalMatchError && displayError"
                class="error"
                v-text="t('member_basic_edit.IC_0115')"/>
            </td>
          </tr>
        </tbody>
      </table>

      <table style="width: 100%;" class="dataTable Display">
        <thead>
          <tr>
            <td colspan="2" class="text-center">
              <h5 class="no-margin" v-text="t('forms.new_individual.IC_0031')"/>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="text-center" v-html="t('forms.new_individual.IC_0032')" />
          </tr>
          <tr>
            <td colspan="2" class="text-center">
              <input type="checkbox" v-model="agreementCheck">
              <span class="required">*</span>
              <span v-text="t('forms.new_individual.IC_0033')" />
            </td>
          </tr>
          <tr>
            <td colspan="2" class="text-center" v-text="t('forms.new_individual.IC_0007')" />
          </tr>
          <tr>
            <td colspan="2" class="text-center">
              <img
                :src="captchaSource"
                alt="CAPTCHA"
                width="84"
                height="27"
                style="margin-bottom: 10px;">
              <i
                class="fa fa-refresh"
                style="font-size: 20px;"
                @click="resetCaptcha"/>
              <input
                v-model="personalInfo.Captcha"
                type="text"
                class="no-margin"
                maxlength="4">
              <small
                v-if="captchaError && displayError"
                class="error"
                v-text="t('xajax.newcontractor.server.IC_0034')"/>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="text-center">
              <button
                class="tiny radius marginTop"
                @click="newIndividual"
                v-text="t('forms.are_you_preregistered.IC_0128')"/>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div
      v-if="!componentReady"
      class="row">
      <div class="columns">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>
    </div>
  </div>
</template>

<script>
import $      from 'jquery';
import _      from 'lodash';
import toastr from 'toastr';

export default {
  data() {
    return {
      personalInfo: {
        Email: '',
        Password: '',
        PasswordMatch: '',
        Firstname: '',
        Lastname: '',
        Title: '',
        Tel: '',
        Cell: '',
        Street: '',
        City: '',
        Postal: '',
        Province: '',
        ProvinceISO: '',
        Country: '',
        CountryCode: '',
        CountryISO: '',
        Captcha: '',
        IgnoreWarning: false,
      },
      commonPassword: [
        'Password123',
        'Safety2014',
        'Safety2015',
        'Safety2016',
        'Safety2017',
      ],
      displayError: false,
      captchaError: false,
      localCountryId: '0',
      localProvinceId: '0',
      displayData: {},
      componentReady: false,
      agreementCheck: false,
    };
  },

  watch: {
    'personalInfo.Captcha' : function () {
      this.captchaError = false;
    },

    localCountryId(val, oldVal) {
      const match = _.find(this.displayData.geoInfo.countries, country =>
        country.CountryID === val);

      if (match) {
        this.personalInfo.Country = match.Name;
        this.personalInfo.CountryCode = match.iso_code_2;
        this.personalInfo.CountryISO = match.iso_code_2;
      } else {
        this.personalInfo.Country = '';
        this.personalInfo.CountryCode = '';
        this.personalInfo.CountryISO = '';
      }

      if (val !== oldVal) {
        this.personalInfo.Province = '';
        this.personalInfo.ProvinceISO = '';
      }
    },

    localProvinceId(val) {
      const match = _.find(this.displayData.geoInfo.provinces, province =>
        province.zone_id === val);

      if (match) {
        this.personalInfo.Province = match.Name;
        this.personalInfo.ProvinceISO = match.code;
      }
    },
  },

  beforeMount() {
    $.post('/register/tab-data/individual', (data) => {
      this.displayData = data;
      this.componentReady = true;
    });
  },

  computed: {
    firstnameError() {
      return this.personalInfo.Firstname === '';
    },

    lastnameError() {
      return this.personalInfo.Lastname === '';
    },

    captchaSource() {
      return `data:image/png;base64,${this.displayData.captchaInfo.image}`;
    },

    emailError() {
      return this.personalInfo.Email === '' || !this.validateEmail(this.personalInfo.Email);
    },

    passwordError() {
      return _.size(this.personalInfo.Password) < 8 || !this.validatePassword(this.personalInfo.Password);;
    },

    telError() {
      return this.personalInfo.Tel === '' || _.size(this.personalInfo.Tel) < 9;
    },

    streetError() {
      return this.personalInfo.Street === '';
    },

    cityError() {
      return this.personalInfo.City === '';
    },

    passwordMatchError() {
      return this.personalInfo.Password === '' ||
        this.personalInfo.Password !== this.personalInfo.PasswordMatch;
    },

    countryError() {
      return this.localCountryId === '0';
    },

    provinceError() {
      return this.localProvinceId === '0';
    },

    postalError() {
      return this.personalInfo.Postal === '';
    },

    postalMatchError() {
      let error = false;

      if (this.personalInfo.CountryISO !== 'CA') {
        return false;
      }

      const postal = this.personalInfo.Postal.replace(/[^a-z0-9]/gi, '').toUpperCase();

      if (_.size(postal) !== 6) {
        error = true;
      }

      if (_.includes(['W', 'Z'], postal.charAt(0))) {
        error = true;
      }

      ['D', 'F', 'I', 'O', 'Q', 'U'].forEach((char) => {
        if (_.includes(postal, char)) {
          error = true;
        }
      });

      const regex = /^[A-Z]\d[A-Za-z]\d[A-Z]\d$/;
      const match = regex.exec(postal);

      if (!match) {
        error = true;
      }

      const provincePostalDistrictMap = new Map();

      provincePostalDistrictMap.set('AB', ['T']);
      provincePostalDistrictMap.set('BC', ['V']);
      provincePostalDistrictMap.set('MB', ['R']);
      provincePostalDistrictMap.set('NB', ['E']);
      provincePostalDistrictMap.set('NL', ['A']);
      provincePostalDistrictMap.set('NT', ['X']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('NU', ['X']);
      provincePostalDistrictMap.set('ON', ['K', 'L', 'M', 'N', 'P']);
      provincePostalDistrictMap.set('PE', ['C']);
      provincePostalDistrictMap.set('NS', ['B']);
      provincePostalDistrictMap.set('QC', ['G', 'H', 'J']);
      provincePostalDistrictMap.set('SK', ['S']);
      provincePostalDistrictMap.set('YT', ['Y']);

      const firstLetter = provincePostalDistrictMap.get(this.personalInfo.ProvinceISO);

      if (!_.includes(firstLetter, postal.charAt(0))) {
        error = true;
      }

      return error;
    },
  },

  methods: {
    validatePassword(password) {
      const rules = [
        /^.{0,7}$/, // shorter than 8 characters
        /^((?![0-9]).)*$/, // does not contain a number
        /^((?![A-Z]).)*$/, // does not contain an upper case letter
        /(.)\1{4}/, // contains more than 4 consecutive characters
      ];

      const passesRules = rules.filter(rule => rule.test(password)).length === 0;

      return passesRules && !_.includes(this.commonPassword, password);
    },

    newIndividual() {
      if (!this.agreementCheck) {
        toastr.error(t('xajax.newcontractor.server.IC_0027'));

        return false;
      }

      this.displayError = true;

      if (this.emailError || this.passwordError || this.passwordMatchError
        || this.firstnameError || this.lastnameError || this.telError
        || this.streetError || this.cityError || this.countryError
        || this.provinceError || this.postalError) {
        $('html, body').animate({ scrollTop: 100 }, 'slow');

        return false;
      }

      var self = this;

      $.post('/register/new-individual', {
        personalInfo: this.personalInfo,
      }, (data) => {
        if (data === 'captcha') {
          this.captchaError = true;
          this.reset();
        } else if (data === 'complete') {
          window.location.href = "/login.php?passthru=my_credentials.php?cwid=2";
        } else if (data === 'duplicate') {
          toastr.error(this.personalInfo.Email + ' already has a personal account in ComplyWorks. '
             + '<br> Please <a class="button mini" href="auth/login">login</a>.');
        } else if (data === 'warning') {
          toastr.warning(this.personalInfo.Email + '  is already registered in ComplyWorks with an existing account. Would you like to continue to <br> <button class="mini" id="confirmationRegister"> Register </button> a personal account or  <br> <a class="button mini" href="auth/login">login</a> under the existing account?', '', {
            allowHtml: true,
            closeButton: false,
            onShown: function(toast) {
                $("#confirmationRegister").click(function(){
                  self.personalInfo.IgnoreWarning = true;

                  self.newIndividual();
                });
              }
            });
        } else {
          toastr.error(data);
        }
      });

      return false;
    },

    reset() {
      this.resetCaptcha();

      this.personalInfo.Password = '';
      this.personalInfo.PasswordMatch = '';
      this.personalInfo.Captcha = '';
    },

    validateEmail(email) {
      const emailValidator = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return emailValidator.test(email);
    },

    getProvinces() {
      return _.filter(this.displayData.geoInfo.provinces, province =>
        province.CountryID === this.localCountryId);
    },

    resetCaptcha() {
      $.post('/register/reset-captcha', {}, (data) => {
        this.displayData.captchaInfo = data;
        this.captchaError = true;
      });
    },
  },
};
</script>
